export default __webpack_public_path__ + "static/media/delete.ec4c9dfb.svg";